import { getDeviceList, setDeviceList } from '@/utils/storage'

export default {
  namespaced: true,
  state () {
    return {
      deciveList: getDeviceList()
    }
  },
  mutations: {
    setDeviceList (state, list) {
      state.deciveList = list
      setDeviceList(state.deciveList)
    }
  },
  actions: {
    clearDeviceList (context) {
      context.commit('setDeviceList', [])
    }
  },
  getters: {
    getDeviceList (state) {
      return state.deciveList
    }
  }
}
